module.exports = __webpack_public_path__ + "img/left-arrow.b5128e14.svg";